import * as React from "react";
import { EventResource } from "client/resources";
import { reduce, map, each } from "lodash";
import InternalLink from "components/InternalLink/InternalLink";
import routeLinks from "../../routeLinks";

interface EventFormatterProps {
    event: EventResource;
}

export interface ResourceLinkItem {
    prefix: string;
    redirect(id: string): string;
}

export class ResourceLink {
    public static linkTo(id: string): string {
        if (!id) {
            return "";
        }
        const lower = id.toLowerCase();
        let redirect = "/not-found";
        each(ResourceLink.mapItems(), (mapItem) => {
            if (lower.indexOf(mapItem.prefix) === 0) {
                redirect = mapItem.redirect(id);
                return false;
            }
        });
        return redirect;
    }

    private static mapItems(): ResourceLinkItem[] {
        const items: ResourceLinkItem[] = [];
        items.push({ prefix: "actiontemplates-", redirect: (id) => routeLinks.library.stepTemplate(id).root });
        items.push({ prefix: "deployments-", redirect: (id) => "/deployments/" + id });
        items.push({ prefix: "environments-", redirect: (id) => routeLinks.infrastructure.environment(id) });
        items.push({ prefix: "feeds-", redirect: (id) => routeLinks.library.feed(id).root});
        items.push({ prefix: "libraryvariablesets-", redirect: (id) => routeLinks.library.variableSet(id) });
        items.push({ prefix: "lifecycles-", redirect: (id) => routeLinks.library.lifecycle(id) });
        items.push({ prefix: "machinepolicies-", redirect: (id) => routeLinks.infrastructure.machinePolicy(id) });
        items.push({ prefix: "machines-", redirect: (id) => routeLinks.infrastructure.machine(id).root });
        items.push({ prefix: "projects-", redirect: (id) => routeLinks.project(id).root });
        items.push({ prefix: "projectgroups-", redirect: (id) => "/projectgroups/" + id });
        items.push({ prefix: "proxys-", redirect: (id) => routeLinks.infrastructure.proxy(id) });
        items.push({ prefix: "proxies-", redirect: (id) => routeLinks.infrastructure.proxy(id) });
        items.push({ prefix: "releases-", redirect: (id) => routeLinks.release(id) });
        items.push({ prefix: "servertasks-", redirect: (id) => routeLinks.task(id).root });
        items.push({ prefix: "tagsets-", redirect: (id) => routeLinks.library.tagSet(id) });
        items.push({ prefix: "teams-", redirect: (id) => routeLinks.configuration.team(id) });
        items.push({ prefix: "tenants-", redirect: (id) => routeLinks.tenant(id).root });
        items.push({ prefix: "users-", redirect: (id) => routeLinks.configuration.user(id) });
        items.push({ prefix: "subscriptions-", redirect: (id) => routeLinks.configuration.subscription(id) });
        items.push({ prefix: "certificates-", redirect: (id) => routeLinks.library.certificate(id) });
        return items;
    }
}

export const EventFormatter: React.StatelessComponent<EventFormatterProps> = props => {
    const message = props.event.Message;
    const isDelete = message.indexOf(" was deleted", message.length - " was deleted".length) !== -1;

    const htmlEncode = (html: string): JSX.Element => {
        return <span>{html}</span>;
    };

    const indexes: any[] = [];
    const references = props.event.MessageReferences;
    if (references && references.length > 0) {
        const refStart = references[0];
        if (refStart.StartIndex !== 0) {
            indexes.push({ ref: null, idx: 0 });
        }

        let lastRef: any = null;
        references.map(reference => {
            if (!lastRef || lastRef.idx !== reference.StartIndex) {
                indexes.push({ ref: reference, idx: reference.StartIndex });
            }
            indexes.push({ ref: null, idx: reference.StartIndex + reference.Length });
            lastRef = reference;
        });

        const refEnd = references[references.length - 1];
        const endIndex = (refEnd.StartIndex + refEnd.Length);
        if (endIndex !== message.length) {
            indexes.push({ ref: null, idx: message.length });
        }
    } else {
        indexes.push({ ref: null, idx: 0 });
        indexes.push({ ref: null, idx: message.length });
    }

    let last: any = null;
    const parts: any[] = [];
    indexes.map(item => {
        if (last) {
            parts.push({ ref: last.ref, msg: message.substring(last.idx, item.idx) });
        }
        last = item;
    });

    const encodedParts = map(parts, (x) => {
        const encMsg = htmlEncode(x.msg);
        if (x.ref) {
            const docId = x.ref.ReferencedDocumentId;
            const href = ResourceLink.linkTo(docId);
            if (docId.toLowerCase().indexOf("interruption")) {
                return <InternalLink to={href}>{encMsg}</InternalLink>;
            } else {
                return encMsg;
            }
        } else {
            return encMsg;
        }
    });

    return (
        <span>
            {React.Children.toArray(encodedParts)}
        </span>
    );
};

export default EventFormatter;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/EventFormatter/EventFormatter.tsx